@import '../../../theme.scss';

verdocs-passcode-dialog {
  font-family: $primary-font;
  box-sizing: border-box;

  div {
    box-sizing: border-box;
  }

  // NOTE: background-overlay and .dialog are handled by verdocs-dialog

  .heading {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    .title {
      font-size: 20px;
      font-weight: 500;
    }
  }

  .step {
    color: #666;
    margin-left: 6px;
  }

  .help-box {
    padding: 0;
    color: black;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }

  .help-details {
    gap: 5px;
    display: flex;
    margin-left: 0;
    font-size: 14px;
    flex-direction: column;
  }

  .help-title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .help-text {
    font-weight: 400;
  }

  .buttons {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;

    verdocs-button {
      margin-left: 16px;
    }
  }
}
